import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, PlusCircle, Store } from 'lucide-react';
import { useProgramContext } from '../../context/ProgramContext';

interface NavItem {
  to: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  label: string;
}

function BottomNav() {
  const { isWalletAddressCollection } = useProgramContext();
  const navItems: NavItem[] = [
    { to: '/app/home', icon: Home, label: 'Home' },
    {
      to: '/app/collect',
      icon: PlusCircle,
      label: isWalletAddressCollection ? 'Collect wallet' : 'Collect VPA',
    },
    { to: '/app/shops', icon: Store, label: 'Shops' },
  ];

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 px-2 sm:px-3 lg:bottom-5"
      style={{ paddingBottom: 'var(--safe-area-inset-bottom)' }}
    >
      <div className="max-w-[980px] mx-auto flex items-center justify-around h-14 bg-white/90 backdrop-blur-xl border border-slate-200/80 rounded-t-2xl lg:rounded-2xl shadow-soft-lg">
        {navItems.map(({ to, icon: Icon, label }) => (
          <NavLink
            key={to}
            to={to}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center flex-1 min-h-[56px] min-w-[56px] gap-0.5 transition-all duration-200 ease-out active:opacity-80 ${
                isActive
                  ? 'text-brand bg-brand/10 border-t-2 border-brand'
                  : 'text-slate-500 border-t-2 border-transparent'
              }`
            }
          >
            <Icon className="w-5 h-5 sm:w-5 sm:h-5 flex-shrink-0" strokeWidth={2.2} />
            <span className="text-[11px] font-semibold leading-tight tracking-[0.01em]">{label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}

export default BottomNav;
